module.exports = __webpack_public_path__ + "assets/media/lunch.4b3f313a.mp3";